import * as ng from 'angular';
import {ValidationService} from '../../../../services/validation.service';
import {ArchiSmallServices} from '../../../../services/archismall.service';
import {appContext} from '../../../../app.context';

class RequestInformationFatturaPaController implements ng.IController {

  static $inject: string[] = [
    '$scope',
    '$rootScope',
    '$state',
    '$http',
    'configuration',
    'store',
    'jwtHelper',
    'ArchiSmallServices',
    '$sce',
    '$uibModal',
    'ValidationService'
  ];

  constructor(
    private $scope: any,
    private $rootScope: any,
    private $state: any,
    private $http: ng.IHttpService,
    private configuration: any,
    private store: ng.a0.storage.IStoreService,
    private jwtHelper: any,
    private ArchiSmallServices: ArchiSmallServices,
    private $sce: any,
    private $uibModal: ng.ui.bootstrap.IModalService,
    private ValidationService: ValidationService
  ) {
    /* tslint:disable:no-string-literal */
    $scope.CodiceFiscaleType = new RegExp('^[A-Z0-9]{11,16}$');
    let init = () => {
      ArchiSmallServices.getUser($rootScope.currentUser().sub)
        .then((response: any) => {
          $rootScope.user = response;
          $scope.user = response;
          store.set('user', response);
          if ($rootScope.user !== undefined) {
            if ($rootScope.user.accountData.userType === 1) {
              $state.go('home.request-information-fattura-pa-lp');
              return;
            }
          } else {
            setTimeout(init, 1000);
          }
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };
    init();
    $scope.trustAsHtml = (value) => {
      return $sce.trustAsHtml(value);
    };
    $scope.refreshStateCodes = () => {
      let country = 'IT';
      ArchiSmallServices.getTypeaheadValues('stateCodes', 'country=' + country)
        .then((response: any) => {
          $scope.stateCodes = response;
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };
    $scope.refreshStateCodes();
    $scope.regimeFiscaleValues = {
      'RF01': 'Ordinario',
      'RF02': 'Contribuenti minimi (art.1, c.96-117, L. 244/07)',
      'RF04': 'Agricoltura e attività connesse e pesca (artt.34 e 34-bis, DPR 633/72)',
      'RF05': 'Vendita sali e tabacchi (art.74, c.1, DPR. 633/72)',
      'RF06': 'Commercio fiammiferi (art.74, c.1, DPR 633/72)',
      'RF07': 'Editoria (art.74, c.1, DPR 633/72)',
      'RF08': 'Gestione servizi telefonia pubblica (art.74, c.1, DPR 633/72)',
      'RF09': 'Rivendita documenti di trasporto pubblico e di sosta (art.74, c.1, DPR 633/72)',
      'RF10': 'Intrattenimenti, giochi e altre attività di cui alla tariffa allegata al DPR 640/72 (art.74, c.6, DPR 633/72)',
      'RF11': 'Agenzie viaggi e turismo (art.74-ter, DPR 633/72',
      'RF12': 'Agriturismo (art.5, c.2, L. 413/91) ',
      'RF13': 'Vendite a domicilio (art.25-bis, c.6, DPR 600/73) ',
      'RF14': 'Rivendita beni usati, oggetti d’arte, d’antiquariato o da collezione (art.36, DL 41/95)',
      'RF15': 'Agenzie di vendite all’asta di oggetti d’arte, antiquariato o da collezione (art.40-bis, DL 41/95) ',
      'RF16': 'IVA per cassa P.A. (art.6, c.5, DPR 633/72) ',
      'RF17': 'IVA per cassa (art. 32-bis, DL 83/2012) ',
      'RF18': 'Altro',
      'RF19': 'Regime forfettario (art.1, c.54-89, L. 190/2014)',
      'RF20': 'Regime transfrontaliero di Franchigia IVA (Direttiva UE 2020/285)'
    };
    $scope.socioUnicoValues = {
      'SU': 'socio unico',
      'SM': 'più soci'
    };
    $scope.statoLiquidazioneValues = {
      'LS': 'in liquidazione',
      'LN': 'non in liquidazione'
    };
    $scope.String20Type = new RegExp('^[\u0000-\u007F]{1,20}$');
    // <editor-fold desc='openFatturazioneConfermaModal'>
    $scope.openFatturazioneConfermaModal = (size) => {

      let FatturazioneConfermaModal = $uibModal.open({
        animation: true,
        component: 'fatturazioneConfermaComponent',
        size: size,
        windowClass: 'center-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {}
      });
    };
    // </editor-fold>

    // <editor-fold desc='DatePicker'>

    $scope.dpOpened = {
      birthDate: false
    };
    $scope.openDP = ($event, opened) => {

      $event.preventDefault();
      $event.stopPropagation();
      $scope.dpOpened[opened] = true;
    };
    $scope.autoOpen = ($event, opened) => {

      if (appContext.userBrowser['isIE']) {
        return;
      }
      $event.preventDefault();
      $event.stopPropagation();
      $scope.dpOpened[opened] = true;
    };
    // </editor-fold>
  }

}

export const RequestInformationFatturaPaComponent: ng.IComponentOptions = {
  template: require('./request-information-fattura-pa.html'),
  controller: RequestInformationFatturaPaController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/request-information-fattura-pa/request-information-fattura-pa.ts